export default __webpack_public_path__ + "static/MRF-Quality-Assurance-Summary-f380d1dceee615ba6c48d156ce7e066f.png";